import {HPPData, HPPDataError} from './types';

export const isHPPDataError = (data: HPPData | HPPDataError): data is HPPDataError => {
  return !!(data as HPPDataError)?.error;
};
